var Ractive = require('ractive');
var component = module;
component.exports.template = {v:4,t:[{p:[1,1,0],t:7,e:"footer",m:[{n:"class",f:"site-footer",t:13}],f:[{p:[2,2,31],t:7,e:"div",m:[{n:"class",f:"site-footer-legal",t:13}],f:["© 2015 ",{p:[2,40,69],t:7,e:"a",m:[{n:"href",f:"http://themeforest.net/item/remark-responsive-bootstrap-admin-template/11989202",t:13}],f:["Remark"]}]}," ",{p:[3,2,178],t:7,e:"div",m:[{n:"class",f:"site-footer-right",t:13}],f:["Crafted with ",{p:[4,16,226],t:7,e:"i",m:[{n:"class",f:"red-600 icon md-favorite",t:13}]}," by ",{p:[4,60,270],t:7,e:"a",m:[{n:"href",f:"http://themeforest.net/user/amazingSurge",t:13}],f:["amazingSurge"]}]}]}]};
module.exports = Ractive.extend(component.exports);



//////////////////
// WEBPACK FOOTER
// ./~/ractive-component-loader!./ractive/Project/ERP/Part/Foot.html
// module id = 35
// module chunks = 0